import React, { FC } from 'react'

import { IconGamingProps } from './IconGaming.types'
import * as Styled from './styles/IconGaming.style'

import { nonThemeableRules } from '../../ruleSet'

const IconGaming: FC<IconGamingProps> = ({
  size = nonThemeableRules.defaultSize as number as IconGamingProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconGamingProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m143.74 129.4-4.41-24.77a32 32 0 0 1-24 15.19 12.11 12.11 0 0 1-2.16 3.86l8.24 14a12 12 0 0 0 22.59-5.76 12.19 12.19 0 0 0-.24-2.42ZM136 88a24 24 0 0 0-24-24H48a24 24 0 0 0-3.22 47.78 12 12 0 0 1 22.52.22h25.4a12 12 0 0 1 22.52-.22A24 24 0 0 0 136 88Zm-80 4h-4v4a4 4 0 0 1-8 0v-4h-4a4 4 0 0 1 0-8h4v-4a4 4 0 0 1 8 0v4h4a4 4 0 0 1 0 8Zm64-8a4 4 0 1 1-4 4 4 4 0 0 1 4-4Zm-8-8a4 4 0 1 1-4 4 4 4 0 0 1 4-4Zm-8 16a4 4 0 1 1 4-4 4 4 0 0 1-4 4Zm8 8a4 4 0 1 1 4-4 4 4 0 0 1-4 4Zm-91.32 4.64-4.44 24.94A12.19 12.19 0 0 0 16 132a12 12 0 0 0 22.55 5.72l.07-.12 8.19-13.89a12.2 12.2 0 0 1-2.18-3.89 32 32 0 0 1-23.95-15.18Z'
          fill='none'
        />
        <path d='M56 84h-4v-4a4 4 0 0 0-8 0v4h-4a4 4 0 0 0 0 8h4v4a4 4 0 0 0 8 0v-4h4a4 4 0 0 0 0-8Z' fill='#333' />
        <path
          d='m151.6 128-7.93-44.57a.29.29 0 0 0 0-.09A32 32 0 0 0 112 56H84V44a4 4 0 0 1 4-4h40a12 12 0 0 0 0-24H88a4 4 0 0 1-4-4V4a4 4 0 0 0-8 0v8a12 12 0 0 0 12 12h40a4 4 0 0 1 0 8H88a12 12 0 0 0-12 12v12H48a32.05 32.05 0 0 0-31.67 27.43L8.4 128a19.59 19.59 0 0 0-.4 4 20 20 0 0 0 37.55 9.6l8.15-13.83a11.65 11.65 0 0 0 2.3.23 12 12 0 0 0 11.3-8h25.4a12 12 0 0 0 13.64 7.77l8.11 13.75a20 20 0 0 0 37.55-9.6 19.52 19.52 0 0 0-.4-3.92Zm-113 9.65-.07.12A12 12 0 0 1 16 132a12.19 12.19 0 0 1 .24-2.42l4.44-24.94a32 32 0 0 0 24 15.18 12.2 12.2 0 0 0 2.18 3.89ZM56 120a4 4 0 1 1 4-4 4 4 0 0 1-4 4Zm48 0a4 4 0 1 1 4-4 4 4 0 0 1-4 4Zm0-16a12 12 0 0 0-11.3 8H67.3a12 12 0 0 0-22.52-.22A24 24 0 0 1 48 64h64a24 24 0 0 1 3.22 47.78A12 12 0 0 0 104 104Zm28 39.92a12 12 0 0 1-10.55-6.28l-8.24-14a12.11 12.11 0 0 0 2.16-3.86 32 32 0 0 0 24-15.19l4.41 24.77v.1a12.19 12.19 0 0 1 .24 2.42A12 12 0 0 1 132 143.92Z'
          fill='#333'
        />
        <circle cx='112' cy='80' fill='#333' r='4' />
        <circle cx='104' cy='88' fill='#333' r='4' />
        <circle cx='120' cy='88' fill='#333' r='4' />
        <circle cx='112' cy='96' fill='#333' r='4' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconGaming
